var Radio = require('backbone.radio');
var PubNub = require('pubnub');
var expireCache = require('expire-cache');
var DateUtils = require('./utils/dates');
const PubSub = Marionette.Object.extend({
    _uuid: null,
    _ONLINE_STATUS_CACHE_TIMEOUT_SECS: 10,
    _pubnubInst: null,
    _onlineStatusCache: null,
    _pubnubTimeOffsetFromClient: null,
    _fetchingPubnubTimeOffsetFromClientDeferred: null,
    initialize: function (options) {
        var self = this;

        this.options = _.defaults(
            options || {},
            {
                logVerbosity: false,
                presenceTimeout: 30,
                uuid: null
            }
        );

        if (_.isEmpty(this.options.subscribeKey) ||
            _.isEmpty(this.options.publishKey))
        {
            throw new Error('Pubnub configuration parameters not supplied');
        }

        this._onlineStatusCache = expireCache.namespace(
            'online:status',
            this._ONLINE_STATUS_CACHE_TIMEOUT_SECS
        );

        this._pubnubInst = new PubNub({
            subscribeKey: this.options.subscribeKey,
            publishKey: this.options.publishKey,
            ssl: true,
            restore: true,
            logVerbosity: this.options.logVerbosity,
            presenceTimeout: this.options.presenceTimeout,
            uuid: this.options.uuid
        });

        // A call to _getPubnubTimeOffsetFromClient here has the effect of setting
        // the pubnub time offset from client which we want as early as possible.
        this._getPubnubTimeOffsetFromClient();

        this._uuid = this._pubnubInst.getUUID();

        console.log('pubsub established UUID: ', this._uuid);

        var pubsubChannel = Backbone.Radio.channel('pubsub');

        pubsubChannel.reply('getUUID', function (options) {
            return self._uuid;
        });

        pubsubChannel.reply('getChannelUUIDs', function (channelName, options) {
            return self.getChannelUUIDs(channelName, options);
        });

        pubsubChannel.reply('getOnlineChannelsForUUID', function (uuid) {
            return self.getOnlineChannelsForUUID(uuid);
        });


        pubsubChannel.reply('getMomentUTCFromTimetoken', function (timetoken) {
            return self.getMomentUTCFromTimetoken(timetoken);
        });

        pubsubChannel.reply('publish', function (channelName, message, options) {
            return self.publish(channelName, message, options);
        });

        pubsubChannel.reply('subscribe', function (channelName, options) {
            return self.subscribe(channelName, options);
        });

        pubsubChannel.reply('getPrivateChannnelName', function (channelName) {
            return self.getPrivateChannnelName(channelName);
        });

        pubsubChannel.reply('isTokenStale', function (token, staleAfterSeconds) {
            return self.isTokenStale(token, staleAfterSeconds);
        });

        pubsubChannel.reply('setState', function (state, channelName) {
            return self._setState(state, channelName);
        });

    },
    getMomentUTCFromTimetoken: function (timetoken) {
        return (moment.utc(timetoken/1e4));
    },
    publish: function (channelName, message, options) {
        var self = this;
        var $deferred = $.Deferred();
        options = _.defaults(
            options || {},
            {
                // Arbritrary data object to be passed with the message.
                meta: {}
            }
        );
        self._pubnubInst.publish(
            {
                message: message,
                channel: channelName,
                meta: options.meta
            },
            function (status, response) {
                if (status.error) {
                    console.log(status);
                    $deferred.reject(status);
                } else {
                    $deferred.resolve(response);
                }
            }
        );
        return $deferred.promise();
    },
    subscribe: function (channelName, options) {
        var self = this;
        if (!_.isArray(channelName)) {
            channelName = [channelName];
        }
        options = _.defaults(
            options || {},
            {
                channelGroups: [],
                withPresence: false
            }
        );

        var notificationsHandler = {
            message: function (message) {
                if (channelName.indexOf(message.channel) === -1) {
                    // Not listening to channel, check for wildcard
                    var wildcardChannelMatch = false;
                    channelName.forEach(function (channel) {
                      var channelArray = channel.split('.*');
                      if (channelArray !== null && channelArray.length > 1) {
                        var messageChannelArray = message.channel.split('.');
                        if (messageChannelArray !== null && messageChannelArray.length > 1) {
                          if (channelArray[0] == messageChannelArray[0]) {
                            wildcardChannelMatch = true;
                          }
                        }
                      }
                    });
                    if (wildcardChannelMatch !== true) {
                      return;
                    }
                }
                if (options.notificationsHandler && options.notificationsHandler.message) {
                    options.notificationsHandler.message(message);
                }
            },
            presence: function (presenceEvent) {
                if (options.notificationsHandler && options.notificationsHandler.presence) {
                    options.notificationsHandler.presence(presenceEvent);
                }
            }
        };

        this._pubnubInst.addListener(notificationsHandler);
        this._pubnubInst.subscribe({
            channels: channelName,
            channelGroups: options.channelGroups,
            withPresence: options.withPresence
        });
        return function unsubscribeCallback () {
            self._pubnubInst.removeListener(notificationsHandler);
        }
    },
    getOnlineChannelsForUUID: function (uuid) {
        var $deferred = $.Deferred();
        this._pubnubInst.whereNow(
            {
                uuid: uuid
            },
            function (status, response) {
                if (status.error) {
                    $deferred.reject();
                } else {
                    $deferred.resolve(response.channels);
                }
            }
        );
        return $deferred.promise();
    },
    getChannelUUIDs: function (channelName, options) {
        var $deferred = $.Deferred();
        var self = this;
        var cachedOnlineStatus = self._onlineStatusCache(channelName);

        if (cachedOnlineStatus) {
            $deferred.resolve(cachedOnlineStatus);
            return $deferred.promise();
        }

        options = _.defaults(
            options || {},
            {
                includeUUIDs: true,
                includeState: true
            }
        );

        this._pubnubInst.hereNow(
            {
                channels: [channelName],
                includeUUIDs: options.includeUUIDs,
                includeState: options.includeState
            },
            function (status, response) {
                if (status.error) {
                    $deferred.reject();
                } else {
                    self._onlineStatusCache(channelName, response.channels[channelName]);
                    $deferred.resolve(self._onlineStatusCache(channelName));
                }
            }
        );
        return $deferred.promise();
    },
    getPrivateChannnelName: function (channelName) {
        return channelName + ':' + this._uuid;
    },
    _getPubnubTime: function () {
        var $deferred = $.Deferred();
        this._pubnubInst.time(function(status, response) {
            if (status.error) {
                $deferred.reject();
            } else {
                $deferred.resolve(response.timetoken);
            }
        });
        return $deferred.promise();
    },
    isTokenStale: function (token, staleAfterSeconds) {
        var $deferred = $.Deferred();
        var tokenMoment = this.getMomentUTCFromTimetoken(token);
        var nowMoment = moment.utc();
        this._getPubnubTimeOffsetFromClient().then(function (offsetMs) {
            if (offsetMs < 0) {
                nowMoment.add(
                    offsetMs,
                    'ms'
                );
            } else {
                nowMoment.subtract(
                    offsetMs,
                    'ms'
                )
            }
            $deferred.resolve(
                nowMoment.diff(
                    tokenMoment,
                    'seconds'
                ) >= staleAfterSeconds);
        });
        return $deferred.promise();
    },
    _setState: function (state, channelName) {
        if (!_.isArray(channelName)) {
            channelName = [channelName];
        }
        this._pubnubInst.setState({
            channels: channelName,
            uuid: this._uuid,
            state: state
        });
    },
    _getPubnubTimeOffsetFromClient: function () {
        var self = this;
        if (self._fetchingPubnubTimeOffsetFromClientDeferred) {
            return self._fetchingPubnubTimeOffsetFromClientDeferred;
        }

        self._fetchingPubnubTimeOffsetFromClientDeferred =  $.Deferred();
        var nowBeforeCallMoment = moment.utc();
        self._getPubnubTime().then(function (timetoken) {
            var nowAfterCallMoment = moment.utc();
            var callLatency = nowAfterCallMoment.diff(nowBeforeCallMoment);
            //console.log('Time call latency: ', callLatency);
            var nowMoment = moment.utc().subtract(callLatency, 'ms');
            var pubnubNowMoment = self.getMomentUTCFromTimetoken(timetoken);
            self._pubnubTimeOffsetFromClient = nowMoment.diff(pubnubNowMoment);
            //console.log('Client diff from pubnub: ', self._pubnubTimeOffsetFromClient);
            self._fetchingPubnubTimeOffsetFromClientDeferred.resolve(self._pubnubTimeOffsetFromClient);
        }).fail(function () {
            self._fetchingPubnubTimeOffsetFromClientDeferred.reject();
            self._fetchingPubnubTimeOffsetFromClientDeferred = null;
        });
        return self._fetchingPubnubTimeOffsetFromClientDeferred;
    },
    broadcastUserTypingStatus: function (channels) {
        var self = this;
        var typingTimeoutId = null;
        $(document).keydown(
            _.debounce(
                function (e) {

                    self._setState(
                        {
                            typing: true
                        },
                        channels
                    );

                    if (typingTimeoutId) {
                        window.clearTimeout(typingTimeoutId);
                        typingTimeoutId = null;
                    }

                    typingTimeoutId = window.setTimeout(function () {
                        self._setState(
                            {
                                typing: false
                            },
                            channels
                        );
                    }, 500);
                },
                50,
                true
            )
        );
    },
    onDestroy: function () {
        this._pubnubInst.stop();
        this._pubnubInst.unsubscribeAll();
    }
});
module.exports = PubSub;



/** WEBPACK FOOTER **
 ** ./assets/js/pubsub.js
 **/